import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import OrderCostSummary from 'app/store/components/common/order-cost-summary';
import { orderPropType, orderItemPropType } from 'app/store/selectors/products';
import { formatPrice } from 'app/util';

import './order.less';

const Item = props => (
  <div className='Item'>
    <div className='description'>
      <h4 className='h4'>{props.name}</h4>
      <div className='subTitle caption'>{props.subTitle}</div>
    </div>
    <div className='ppCost'>{formatPrice(props.price)} /ea.</div>
    <div className='quantity'>x {props.quantity}</div>
    <div className='totalCost'>{formatPrice(props.amount)}</div>
  </div>
);

Item.propTypes = {
  ...orderItemPropType,
};

const Order = (props) => {
  const items = _.map(props.items, (item, index) => <Item key={index} {...item} />);

  let warning;
  if (props.warning) {
    warning = <div className='warning'>{props.warning}</div>;
  }

  return (
    <div className='Order container'>
      {warning}
      <div className='baseInfo'>
        <div className='orderDate'>
          <div className='caption'>Order Placed</div>
          <div>{moment(props.createdAt).format('LL')}</div>
        </div>
        <div className='orderNumber'>
          <div className='caption'>Order Number</div>
          <div>{props.number}</div>
        </div>
      </div>
      {items}
      <OrderCostSummary {...props} />
    </div>
  );
};

Order.propTypes = {
  ...orderPropType,
};

export default Order;



// WEBPACK FOOTER //
// ./app/components/settings/order.jsx